export default "__VITE_ASSET__DRqmh8xb__"